import type { JourneyMacroId, JourneyMacroStage } from '@/components/Deals/dealsJourney.constants'
import { getJourneyColumnMetrics } from '@/components/Deals/journeyColumnMetrics'
import type { Deal } from '@/types'

export type JourneyPipelineStep = {
  macro: JourneyMacroStage
  count: number
  value: number
  atRisk: number
  pct: number
}

export function getJourneyPipelineSummary(
  macros: JourneyMacroStage[],
  grouped: Partial<Record<JourneyMacroId, Deal[]>>,
) {
  let totalValue = 0
  let totalAtRisk = 0

  const steps: JourneyPipelineStep[] = macros.map((macro) => {
    const deals = grouped[macro.id] ?? []
    const metrics = getJourneyColumnMetrics(deals)
    totalValue += metrics.value
    totalAtRisk += metrics.atRisk
    return {
      macro,
      count: metrics.count,
      value: metrics.value,
      atRisk: metrics.atRisk,
      pct: 0,
    }
  })

  const total = steps.reduce((sum, step) => sum + step.count, 0)
  for (const step of steps) {
    step.pct = total > 0 ? Math.round((step.count / total) * 100) : 0
  }

  return { total, totalValue, totalAtRisk, steps }
}
